var map = {
	"./DataViz_high.mp4": "7240",
	"./DataViz_low.mp4": "26c8",
	"./DataViz_med.mp4": "a195",
	"./ResponsiveText.mp4": "351a",
	"./Speaker_high.mp4": "3ad3",
	"./Speaker_low.mp4": "83c6",
	"./Speaker_lower_3rd.mp4": "5c08",
	"./Speaker_med.mp4": "7f3c",
	"./Speaker_waveform.mp4": "8af3",
	"./Text_center_+_sub.mp4": "a7cd",
	"./Text_center_high.mp4": "92df",
	"./Text_center_low.mp4": "7651",
	"./Text_center_med.mp4": "1e33",
	"./Text_headline_+_16x9.mp4": "13cf",
	"./Text_headline_+_1x1.mp4": "af83",
	"./Text_headline_+_9x16.mp4": "1b72",
	"./Text_left.mp4": "acb9",
	"./Text_left_+_sub.mp4": "17ae",
	"./Text_quote_center.mp4": "832d",
	"./Text_quote_left.mp4": "88c7",
	"./ii_toolkit-tutorial.mp4": "085e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4217";